/* eslint-disable jira/filename-case */
export const getSortFieldAndDirection = (
	sortByFromUserPrefs: string | number | boolean | undefined,
):
	| {
			readonly sortField?: undefined;
			readonly sortDirection?: undefined;
	  }
	| {
			readonly sortField: string;
			readonly sortDirection: 'ASC' | 'DESC';
	  } => {
	const [sortField, sortDirection] =
		typeof sortByFromUserPrefs === 'string' ? sortByFromUserPrefs.split(':') : [];
	if (!sortField || (sortDirection !== 'ASC' && sortDirection !== 'DESC')) {
		return {};
	}
	return {
		sortField,
		sortDirection,
	} as const;
};
